import { UserIdentityModel } from "client/Api/UserProfile/service";
import { UserListItem } from "client/Features/Users/UserListItem/UserListItem";
import { generateTrackingId, setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import styles from "./UserList.module.less";

export type UserListProps = {
	items: readonly UserIdentityModel[];
	renderAfterItems: ReactElement;
};

export const UserList = (props: UserListProps): ReactElement => {
	const {
		items,
		renderAfterItems
	} = props;

	return (
		<ul
			{...setTrackingId("user-list")}
			className={styles.root}
		>
			{items.map(
				x => (
					<li key={x.userId}>
						<UserListItem
							user={x}
							trackingId={generateTrackingId("user-item", `|${x.userId}`)}
							noMobileBorderBottom
						/>
					</li>
				)
			)}
			<li>
				{renderAfterItems}
			</li>
		</ul>
	);
};
UserList.displayName = "UserList";